import React from "react";

import parse from "html-react-parser";
import styled from "styled-components";
import SketchfabViewer from "../../../SketchfabViewer";
import YoutubeViewer from "../../../YoutubeViewer";
import { Link } from "react-router-dom";

const Entry3D = ({ data, handleImageModal }) => {
  return (
    <>
      <Styled3D>
        {(data.content.featured_image ||
          data.content.description ||
          data.content.important_links ||
          (data.meta.tags && Object.keys(data.meta.tags.length) > 0)) && (
          <div className="side-content">
            {data.content.featured_image && (
              <img
                src={`https://res.cloudinary.com/rauru/image/upload/v1601074827/${data.content.featured_image}`}
                className="responsive-img"
                alt="featured"
                onClick={() => {
                  handleImageModal(
                    `https://res.cloudinary.com/rauru/image/upload/v1601074827/${data.content.featured_image}`
                  );
                }}
              />
            )}
            <div>{parse(data.content.description)}</div>
            {data.content.important_links && (
              <fieldset>
                <legend>Important Links</legend>
                {data.content.important_links.map((url, i) => (
                  <div className="link" key={`link-${i}`}>
                    <a href={url}>{url}</a>
                  </div>
                ))}
              </fieldset>
            )}
            {data.meta.tags && Object.keys(data.meta.tags).length > 0 && (
              <fieldset className="tags">
                <legend>Tags</legend>
                {Object.keys(data.meta.tags).map((tag, i) => (
                  <div className="tag" key={`tag-${i}`}>
                    <Link to={`/blog/1?tag=${tag}`}>{tag.replace("_", " ")}</Link>
                  </div>
                ))}
              </fieldset>
            )}
          </div>
        )}
        <div className="content">
          <div>
            <SketchfabViewer modelURL={data.content.model_URL} width="100%" />
          </div>

          {data.content.images && (
            <fieldset>
              <legend>Images</legend>
              {data.content.images.map((image, i) => (
                <img
                  src={`https://res.cloudinary.com/rauru/image/upload/c_thumb,h_100/v1601074827/${image}`}
                  key={`image-${i}`}
                  alt={image}
                  className="gallery-thumb"
                  onClick={() => {
                    handleImageModal(
                      `https://res.cloudinary.com/rauru/image/upload/v1601074827/${image}`
                    );
                  }}
                />
              ))}
            </fieldset>
          )}
          {data.content.videos && (
            <fieldset>
              <legend>Videos</legend>
              {data.content.videos.map((video, i) => (
                <YoutubeViewer
                  videoUrl={video}
                  key={`video-${i}`}
                  width={256}
                  height={144}
                />
              ))}
            </fieldset>
          )}
        </div>
      </Styled3D>
    </>
  );
};

const Styled3D = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column-reverse;
  padding: 0.6rem;
  .side-content {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  @media (min-width: 1200px) {
    flex-direction: row;
    .side-content {
      width: 30%;
    }
    .content {
      width: 70%;
      padding: 0 2rem;
    }
    .tags {
      width: 85%;
    }
  }
`;

export default Entry3D;
